import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref } from "vue";
const _hoisted_1 = { class: "bg-white d-flex w-100 position-fixed academic-sidebar-wrapper" };
const _hoisted_2 = { class: "footer-ul p-0 w-100 align-items-center d-flex h-100" };
const _hoisted_3 = { id: "home" };
const _hoisted_4 = { id: "calendar" };
const _hoisted_5 = {
    id: "alerts",
    class: "position-relative"
};
const _hoisted_6 = { class: "alerts-container-wrapper position-absolute" };
const _hoisted_7 = {
    id: "notifications",
    class: "position-relative"
};
const _hoisted_8 = {
    key: 0,
    id: "menu"
};
const _hoisted_9 = {
    key: 1,
    id: "avatar"
};
const _hoisted_10 = {
    key: 0,
    class: "position-absolute bg-white sidebar-select-container"
};
const _hoisted_11 = { class: "select-ul p-0 m-0 d-flex flex-column gap-2" };
const _hoisted_12 = {
    key: 0,
    id: "class",
    class: "custom-border-bottom px-3 py-2"
};
const _hoisted_13 = {
    key: 1,
    id: "grades",
    class: "custom-border-bottom px-3 py-2"
};
const _hoisted_14 = {
    key: 2,
    id: "warnings",
    class: "custom-border-bottom px-3 py-2"
};
const _hoisted_15 = {
    id: "social-chat",
    class: "custom-border-bottom px-3 py-2"
};
const _hoisted_16 = {
    key: 3,
    id: "financial",
    class: "custom-border-bottom px-3 py-2"
};
const _hoisted_17 = {
    key: 4,
    id: "email",
    class: "custom-border-bottom px-3 py-2"
};
const _hoisted_18 = {
    id: "logout",
    class: "custom-border-bottom px-3 py-2"
};
const _hoisted_19 = {
    id: "profile",
    class: "custom-border-bottom px-3 py-2"
};
const _hoisted_20 = { class: "avatar-section me-2" };
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import AvatarCard from '../cards/AvatarCard.vue';
import AlertsInMobileCard from '../cards/AlertsInMobileCard.vue';
import { redirectToUserProfile } from '@/utils/helpers';
import HomeSVG from '../CustomSVG/HomeSVG.vue';
import CalendarSVG from '../CustomSVG/CalendarSVG.vue';
import WarningsSVG from '../CustomSVG/WarningsSVG.vue';
import MenuSVG from '../CustomSVG/MenuSVG.vue';
import ClassSVG from '../CustomSVG/ClassSVG.vue';
import GradesSVG from '../CustomSVG/GradesSVG.vue';
import LogOutSVG from '../CustomSVG/LogOutSVG.vue';
import NotificationItems from '../items/NotificationItems.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AcademicSidebar',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        const disciplineData = computed(() => store.getters.getDisciplineData);
        const viewRelatedToDisciplines = computed(() => Boolean(disciplinesViews.includes(route.name)));
        const renderPrivateRoutes = computed(() => Boolean(userRole.value !== 'student'));
        const renderEmailOption = computed(() => ['teacher', 'tutor'].includes(userRole.value));
        const activeSelectName = computed(() => store.getters.getSelectName);
        const userToken = computed(() => store.getters.getToken);
        const userRole = computed(() => store.getters.getType);
        const userId = computed(() => store.getters.getId);
        const sidebarSelectState = ref(false);
        const alertSelectState = ref(false);
        const disciplinesViews = ['Discipline Class', 'Discipline Grades', 'Discipline Material', 'Questionnaire Feedback',
            'Questionnaire Answers', 'Questionnaire Attempt', 'Questionnaire', 'Assigment Attempt', 'Assigment Overview',
            'Attempt Feedback', 'Assignment Management'];
        const handleSidebarSelectState = () => {
            if (!sidebarSelectState.value) {
                setTimeout(() => {
                    store.dispatch('setSelectData', { selectName: 'sideBarSelect', selectWrapperDiv: '.sidebar-select-container' });
                    sidebarSelectState.value = true;
                }, 0);
                return;
            }
            sidebarSelectState.value = false;
        };
        const handleAlertSelectState = () => {
            if (!alertSelectState.value) {
                setTimeout(() => {
                    store.dispatch('setSelectData', { selectName: 'sideBarAlertSelect', selectWrapperDiv: '.sidebar-select-container' });
                    alertSelectState.value = true;
                }, 0);
                return;
            }
            alertSelectState.value = false;
        };
        const validateSelectStates = () => {
            if (sidebarSelectState.value && activeSelectName.value !== 'sideBarSelect')
                handleSidebarSelectState();
            if (alertSelectState.value && activeSelectName.value !== 'sideBarAlertSelect')
                handleAlertSelectState();
        };
        const redirectToOtherView = (viewName) => {
            router.push({ name: viewName,
                ...viewRelatedToDisciplines.value && { params: { id: disciplineData?.value?.id || null } }
            });
        };
        const renderButtonInBold = (buttonRedirectName) => {
            if (buttonRedirectName === 'Profile View' && route.name === 'Profile View') {
                return !!userId.value && route?.params?.id == userId.value.toString() ?
                    'fw-bold' : 'fw-normal';
            }
            if (route.name === buttonRedirectName)
                return 'fw-bold';
        };
        const logOutUser = async () => {
            await store.dispatch('logout', { userToken: userToken.value });
            router.push({ name: "Login" });
        };
        watch(activeSelectName, () => {
            validateSelectStates();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("ul", _hoisted_2, [
                    _createElementVNode("li", _hoisted_3, [
                        _createElementVNode("button", {
                            id: "My Disciplines",
                            onClick: _cache[0] || (_cache[0] = ($event) => (redirectToOtherView('My Disciplines'))),
                            class: "routment-button border-0 bg-transparent"
                        }, [
                            _createVNode(HomeSVG)
                        ])
                    ]),
                    _createElementVNode("li", _hoisted_4, [
                        _createElementVNode("button", {
                            id: "Calendar View",
                            onClick: _cache[1] || (_cache[1] = ($event) => (redirectToOtherView('Calendar View'))),
                            class: "routment-button border-0 bg-transparent"
                        }, [
                            _createVNode(CalendarSVG)
                        ])
                    ]),
                    _createElementVNode("li", _hoisted_5, [
                        _createElementVNode("button", {
                            onClick: handleAlertSelectState,
                            class: "warning-button border-0 bg-transparent"
                        }, [
                            _createVNode(WarningsSVG)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_Transition, { name: "slide-up-down" }, {
                                default: _withCtx(() => [
                                    (alertSelectState.value)
                                        ? (_openBlock(), _createBlock(AlertsInMobileCard, {
                                            key: 0,
                                            class: "alerts-container"
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ])
                    ]),
                    _createElementVNode("li", _hoisted_7, [
                        _createVNode(NotificationItems, { renderedInSidebar: true })
                    ]),
                    ((!renderPrivateRoutes.value && (viewRelatedToDisciplines.value) || renderPrivateRoutes.value))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                            _createElementVNode("button", {
                                onClick: handleSidebarSelectState,
                                class: "handle-select-button border-0 bg-transparent"
                            }, [
                                _createVNode(MenuSVG)
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("li", _hoisted_9, [
                            _createElementVNode("div", {
                                onClick: _cache[2] || (_cache[2] = ($event) => (handleSidebarSelectState())),
                                class: "cursor-pointer avatar-section"
                            }, [
                                _createVNode(AvatarCard, { renderBorder: true })
                            ])
                        ]))
                ]),
                _createVNode(_Transition, { name: "slide-up-down" }, {
                    default: _withCtx(() => [
                        (sidebarSelectState.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("ul", _hoisted_11, [
                                    (viewRelatedToDisciplines.value)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                                            _createElementVNode("button", {
                                                id: "Discipline Class",
                                                onClick: _cache[3] || (_cache[3] = ($event) => (redirectToOtherView('Discipline Class'))),
                                                class: _normalizeClass([renderButtonInBold('Discipline Class'), 'routment-button select-button border-0 bg-transparent'])
                                            }, [
                                                _createVNode(ClassSVG, { class: "me-2" }),
                                                _cache[10] || (_cache[10] = _createTextVNode(" Turma ", -1))
                                            ], 2)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (viewRelatedToDisciplines.value)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                                            _createElementVNode("button", {
                                                id: "Discipline Grades",
                                                onClick: _cache[4] || (_cache[4] = ($event) => (redirectToOtherView('Discipline Grades'))),
                                                class: _normalizeClass([renderButtonInBold('Discipline Grades'), 'routment-button select-button border-0 bg-transparent'])
                                            }, [
                                                _createVNode(GradesSVG, { class: "me-2" }),
                                                _cache[11] || (_cache[11] = _createTextVNode(" Notas ", -1))
                                            ], 2)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (renderPrivateRoutes.value)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                                            _createElementVNode("button", {
                                                id: "Warning View",
                                                onClick: _cache[5] || (_cache[5] = ($event) => (redirectToOtherView('Warning View'))),
                                                class: _normalizeClass([renderButtonInBold('Warning View'), 'routment-button select-button border-0 bg-transparent'])
                                            }, [
                                                _createVNode(WarningsSVG, { class: "me-2" }),
                                                _cache[12] || (_cache[12] = _createTextVNode(" Gerenciar avisos ", -1))
                                            ], 2)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("li", _hoisted_15, [
                                        _createElementVNode("button", {
                                            id: "Chat View",
                                            onClick: _cache[6] || (_cache[6] = ($event) => (redirectToOtherView('Chat View'))),
                                            class: _normalizeClass([renderButtonInBold('Chat View'), 'routment-button select-button border-0 bg-transparent'])
                                        }, [...(_cache[13] || (_cache[13] = [
                                                _createElementVNode("i", { class: "bi bi-chat-text me-2" }, null, -1),
                                                _createTextVNode(" Mensagens ", -1)
                                            ]))], 2)
                                    ]),
                                    (!renderPrivateRoutes.value)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                                            _createElementVNode("button", {
                                                id: "Financial Student",
                                                onClick: _cache[7] || (_cache[7] = ($event) => (redirectToOtherView('Financial Student'))),
                                                class: _normalizeClass([renderButtonInBold('Financial Student'), 'routment-button select-button border-0 bg-transparent'])
                                            }, [...(_cache[14] || (_cache[14] = [
                                                    _createElementVNode("i", { class: "bi bi-cash-coin me-2" }, null, -1),
                                                    _createTextVNode(" Financeiro ", -1)
                                                ]))], 2)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (renderEmailOption.value)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                                            _createElementVNode("button", {
                                                id: "Email View",
                                                onClick: _cache[8] || (_cache[8] = ($event) => (redirectToOtherView('Email View'))),
                                                class: _normalizeClass([renderButtonInBold('Email View'), 'routment-button select-button border-0 bg-transparent'])
                                            }, [...(_cache[15] || (_cache[15] = [
                                                    _createElementVNode("i", { class: "bi bi-envelope-fill me-2" }, null, -1),
                                                    _createTextVNode(" Email ", -1)
                                                ]))], 2)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("li", _hoisted_18, [
                                        _createElementVNode("button", {
                                            onClick: logOutUser,
                                            class: "select-button log-out-button align-items-center d-flex border-0 bg-transparent"
                                        }, [
                                            _createVNode(LogOutSVG, { class: "me-2" }),
                                            _cache[16] || (_cache[16] = _createTextVNode(" Sair ", -1))
                                        ])
                                    ]),
                                    _createElementVNode("li", _hoisted_19, [
                                        _createElementVNode("button", {
                                            onClick: _cache[9] || (_cache[9] = ($event) => (_unref(redirectToUserProfile)(userId.value || null))),
                                            class: _normalizeClass([renderButtonInBold('Profile View'), 'select-button profile-button align-items-center d-flex border-0 bg-transparent'])
                                        }, [
                                            _createElementVNode("div", _hoisted_20, [
                                                _createVNode(AvatarCard, { renderBorder: true })
                                            ]),
                                            _cache[17] || (_cache[17] = _createTextVNode(" Perfil ", -1))
                                        ], 2)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
